module.exports = __webpack_public_path__ + "static/media/logo.369b360a.svg";